import { render, staticRenderFns } from "./WalletLoginModal.vue?vue&type=template&id=fe85afa8&scoped=true&"
import script from "./WalletLoginModal.vue?vue&type=script&lang=js&"
export * from "./WalletLoginModal.vue?vue&type=script&lang=js&"
import style0 from "./WalletLoginModal.vue?vue&type=style&index=0&id=fe85afa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe85afa8",
  null
  
)

export default component.exports